/* eslint-disable @next/next/no-html-link-for-pages */
import Image from 'next/image'
import Link from 'next/link'
import { memo } from 'react'
import useUploadStore from '../../store/uploadStore'

const Footer = () => {
  const { categoryList } = useUploadStore()
  // console.log(categoryList)
  return (
    <div className="flex h-1/2 w-full flex-row flex-wrap items-start justify-between bg-black p-10 font-oswaldregular text-white">
      <div className="flex flex-col items-start">
        <Image src="/alter_logo.png" alt="alter-logo" width={120} height={30} />
        <span className="font-oswaldregular text-sm">
          The Operating System for Alter.game universe.
        </span>
        <div className="footer bottom-0 mt-4 w-full md:pb-2">
          <div className="mb-8 flex justify-center">
            <a
              href="https://instagram.com/alterdotgame"
              target="_blank"
              className="social-icon mx-2 block"
              rel="noreferrer"
            >
              <Image
                src="/alter_instagram_y.png"
                alt=""
                width={45}
                height={40}
              />
            </a>
            <a
              href="https://twitter.com/AlterDotGame"
              target="_blank"
              className="social-icon mx-2 block"
              rel="noreferrer"
            >
              <Image src="/alter_twitter_y.png" alt="" width={45} height={40} />
            </a>
            <a
              href="https://www.linkedin.com/company/alterdotgame/"
              target="_blank"
              className="social-icon mx-2 block"
              rel="noreferrer"
            >
              <Image
                src="/alter_linkedin_y.png"
                alt=""
                width={45}
                height={40}
              />
            </a>
            <a
              href="https://discord.gg/ChRBJm7yfa"
              target="_blank"
              className="social-icon mx-2 block"
              rel="noreferrer"
            >
              <Image src="/alter_discord_y.png" alt="" width={45} height={40} />
            </a>
            <a
              href="https://www.youtube.com/channel/UCvHUDXeYkP8ZzNgHzIEjpnw"
              target="_blank"
              className="social-icon mx-2 block"
              rel="noreferrer"
            >
              <Image src="/alter_youtube_y.png" alt="" width={45} height={40} />
            </a>
          </div>
        </div>
      </div>
      <div className="flex flex-col items-start">
        <span className="mb-2 font-oswaldregular text-xl">LINKS</span>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          DOWNLOAD
        </span>
        <a href='https://alter.game/whitepaper' target="_blank" className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline" rel="noreferrer" >
          WHITEPAPER
        </a>
        <a href='/' className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          SHOP
        </a>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          MAP
        </span>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          CREATORS
        </span>
      </div>
      <div className="flex w-1/2 flex-col items-start md:w-auto">
        <span className="mb-2 font-oswaldregular text-xl">MARKETPLACE</span>
        {categoryList.map((category, index) => {
          if(index === 0) return
          return <Link href={`/categories/${category.key}`} key={index}>
            <span  className="text-md uppercase mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">

            {category.name}
            </span>
          </Link>
})}
      </div>

      <div className="mt-10 flex w-1/2 flex-col items-start md:mt-0 md:w-auto">
        <span className="mb-2 font-oswaldregular text-xl">INFO</span>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          FAQ
        </span>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          TERMS OF SERVICE
        </span>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          PRIVACY POLICY
        </span>
        <span className="text-md mt-3 font-oswaldregular opacity-60 hover:cursor-pointer hover:underline">
          CONTACT US
        </span>
      </div>

      <div className="mt-10 flex flex-col items-start md:mt-0">
        <span className="mb-4 font-oswaldregular text-xl">DIVE IN</span>
        <button className="w-80 -skew-x-12 transform bg-white/20 p-2 hover:bg-white/30 md:w-64">
          <div className="flex skew-x-12 transform flex-row items-center justify-start pl-4">
            <Image alt="play" src="/play.png" width={36} height={36} />
            <div className="ml-2 flex flex-col items-start">
              <span className="text-sm">Download from</span>
              <span className="text-2xl">Google Play</span>
            </div>
          </div>
        </button>
      </div>
    </div>
  )
}

export default memo(Footer)
